/**
 * 一些基础功能的埋点
 * 基础功能的埋点为了便于进行数据的统计和分析，前缀需为 COMMON_ 开头
 */

export default {
    /* 顶部栏胶囊图 start */
    COMMON_T_C_P_O: '推广返佣胶囊图',
    /* 顶部栏胶囊图 end */

    COMMON_C_D_L: '展开/隐藏菜单栏', // addition：{ "status": '1', // 0-隐藏 1-展开 }

    /* 系统消息通知 start */
    COMMON_S_N_O: '打开系统通知弹窗',
    COMMON_S_N_1: '标为已读',
    COMMON_S_N_2: '全部标为已读',
    COMMON_S_N_3: '以后不再弹窗', // addition：{ "status": '1', // 0-关闭 1-开启 }
    /* 系统消息通知 end */

    /* 任务中心 start */
    COMMON_T_S_0: '打开任务中心',
    COMMON_T_S_1: '已完成', // 切换tab
    COMMON_T_S_2: '进行中', // 切换tab
    COMMON_T_S_3: '已完成的任务状态', // addition：{"status": '1', // 0-失败 1-成功  "taskid": '1', // 任务id
    COMMON_T_S_4: '查看任务',
    /* 任务中心 end */

    COMMON_H_E_P: '打开帮助中心',

    /* 个人中心 start */
    COMMON_U_S_0: '打开个人中心',
    COMMON_U_S_1: '切换在线状态', // addition：{ "status": '1', // 0-离线 1-在线 2-忙碌 }
    COMMON_U_S_2: '切换项目',
    COMMON_U_S_2_0: '跳转项目', // addition：{ "id": '1', // 选中的项目id }
    COMMON_U_S_2_1: '添加项目',
    COMMON_U_S_2_2: '设置项目',
    COMMON_U_S_3: '账号信息',
    COMMON_U_S_4: '系统语言', // addition：{ "lang": 'zh-CN', // 选中语言的code }
    COMMON_U_S_5: '多端下载',
    COMMON_U_S_6: '推广返佣',
    COMMON_U_S_7: '退出登录',
    /* 个人中心 end */

    /* 左下角卡片 start */
    COMMON_C_P_0: '切换项目（左下）',
    COMMON_C_P_1: '跳转项目', // addition：{ "id": '1', // 选中的项目id }
    COMMON_C_P_2: '添加项目',
    COMMON_C_P_3: '设置项目',
    COMMON_C_P_4: '查看套餐详情',
    COMMON_C_P_5: '开通自动续订',
    /* 左下角卡片 end */

    /* 25.06年中活动 start */
    // 年中活动-弹窗
    P_M_25_6_P: '25.06年中活动预热弹窗',
    P_M_25_6_I: '25.06年中活动进行中弹窗',
    P_M_25_6_C: '25.06年中活动倒计时弹窗',
    /* 25.06年中活动 end */

    /** 25.11 活动 start */
    COMMON_P_M_25_11_V: '25.11年终活动弹窗显示',
    COMMON_P_M_25_11_T_C: '25.11年终活动胶囊图点击',
    COMMON_P_M_25_11_P: '25.11年终活动预热弹窗',
    COMMON_P_M_25_11_I: '25.11年终活动进行中弹窗',
    COMMON_P_M_25_11_C: '25.11年终活动倒计时弹窗',
    COMMON_P_M_25_11_M: '25.11年终活动支付成功',
    /** 25.11 活动 end */

    /** 费用中心 */
    COMMON_F_P_M_O: '支付成功后推广弹窗_显示',
    COMMON_F_P_M_N: '支付成功后推广弹窗_不再提醒',
    /** 费用中心 end */

    /** 富文本编辑器 */
    COMMON_T_E_M_1: '富文本_菜单_文件_新建文档',
    COMMON_T_E_M_2: '富文本_菜单_文件_预览',
    COMMON_T_E_M_3: '富文本_菜单_编辑_撤销',
    COMMON_T_E_M_4: '富文本_菜单_编辑_重做',
    COMMON_T_E_M_5: '富文本_菜单_编辑_剪切',
    COMMON_T_E_M_6: '富文本_菜单_编辑_复制',
    COMMON_T_E_M_7: '富文本_菜单_编辑_粘贴',
    COMMON_T_E_M_8: '富文本_菜单_编辑_粘贴为文本',
    COMMON_T_E_M_9: '富文本_菜单_编辑_全选',
    COMMON_T_E_M_10: '富文本_菜单_编辑_查找和替换',
    COMMON_T_E_M_11: '富文本_菜单_查看_代码',
    COMMON_T_E_M_12: '富文本_菜单_查看_网格线',
    COMMON_T_E_M_13: '富文本_菜单_查看_区块边框',
    COMMON_T_E_M_14: '富文本_菜单_查看_全屏',
    COMMON_T_E_M_15: '富文本_菜单_插入_图片',
    COMMON_T_E_M_16: '富文本_菜单_插入_链接',
    COMMON_T_E_M_17: '富文本_菜单_插入_媒体文件',
    COMMON_T_E_M_18: '富文本_菜单_插入_特殊字符',
    COMMON_T_E_M_19: '富文本_菜单_插入_水平线',
    COMMON_T_E_M_20: '富文本_菜单_插入_锚点',
    COMMON_T_E_M_21: '富文本_菜单_格式_加粗',
    COMMON_T_E_M_22: '富文本_菜单_格式_斜体',
    COMMON_T_E_M_23: '富文本_菜单_格式_下划线',
    COMMON_T_E_M_24: '富文本_菜单_格式_删除线',
    COMMON_T_E_M_25: '富文本_菜单_格式_上标',
    COMMON_T_E_M_26: '富文本_菜单_格式_下标',
    COMMON_T_E_M_27: '富文本_菜单_格式_代码格式',
    COMMON_T_E_M_28: '富文本_菜单_格式_移除格式',
    COMMON_T_E_M_29: '富文本_菜单_表格_单元格属性',
    COMMON_T_E_M_30: '富文本_菜单_表格_合并单元格',
    COMMON_T_E_M_31: '富文本_菜单_表格_拆分单元格',
    COMMON_T_E_M_32: '富文本_菜单_表格_行_上方插入行',
    COMMON_T_E_M_33: '富文本_菜单_表格_行_下方插入行',
    COMMON_T_E_M_34: '富文本_菜单_表格_行_删除行',
    COMMON_T_E_M_35: '富文本_菜单_表格_行_属性',
    COMMON_T_E_M_36: '富文本_菜单_表格_行_剪切',
    COMMON_T_E_M_37: '富文本_菜单_表格_行_复制',
    COMMON_T_E_M_38: '富文本_菜单_表格_行_粘贴到上方',
    COMMON_T_E_M_39: '富文本_菜单_表格_行_粘贴到下面',
    COMMON_T_E_M_40: '富文本_菜单_表格_属性',
    COMMON_T_E_M_41: '富文本_菜单_表格_删除',
    COMMON_T_E_M_42: '富文本_菜单_表格_列_左侧插入',
    COMMON_T_E_M_43: '富文本_菜单_表格_列_右侧插入',
    COMMON_T_E_M_44: '富文本_菜单_表格_列_删除',
    COMMON_T_E_M_45: '富文本_菜单_表格_列_剪切',
    COMMON_T_E_M_46: '富文本_菜单_表格_列_复制',
    COMMON_T_E_M_47: '富文本_菜单_表格_列_粘贴到前方',
    COMMON_T_E_M_48: '富文本_菜单_表格_列_粘贴到后方',

    COMMON_T_E_B_1: '富文本_工具栏_撤销',
    COMMON_T_E_B_2: '富文本_工具栏_重做',
    COMMON_T_E_B_3: '富文本_工具栏_加粗',
    COMMON_T_E_B_4: '富文本_工具栏_斜体',
    COMMON_T_E_B_5: '富文本_工具栏_左对齐',
    COMMON_T_E_B_6: '富文本_工具栏_居中对齐',
    COMMON_T_E_B_7: '富文本_工具栏_右对齐',
    COMMON_T_E_B_8: '富文本_工具栏_两端对齐',
    COMMON_T_E_B_9: '富文本_工具栏_减少缩进',
    COMMON_T_E_B_10: '富文本_工具栏_增加缩进',
    COMMON_T_E_B_11: '富文本_工具栏_链接',
    COMMON_T_E_B_12: '富文本_工具栏_图片',
    COMMON_T_E_B_13: '富文本_工具栏_全屏',
    COMMON_T_E_B_14: '富文本_工具栏_水平线',
    COMMON_T_E_B_15: '富文本_工具栏_查看代码',
    COMMON_T_E_B_16: '富文本_工具栏_移除格式',
    COMMON_T_E_B_17: '富文本_工具栏_自定义变量',

    COMMON_T_E_C_1: '富文本_指令_段落格式',
    COMMON_T_E_C_2: '富文本_指令_修改字号',
    COMMON_T_E_C_3: '富文本_指令_行高',
    COMMON_T_E_C_4: '富文本_指令_符号列表',
    COMMON_T_E_C_5: '富文本_指令_有序列表',
    COMMON_T_E_C_8: '富文本_指令_插入表格',
    COMMON_T_E_C_9: '富文本_指令_字体',
    COMMON_T_E_C_6: '富文本_指令_字体颜色',
    COMMON_T_E_C_7: '富文本_指令_字体颜色',
    /** 富文本编辑器 end */
    /** 图片预览组件 */
    COMMON_P_E_T_B: '图片预览组件提取文本_点击',
    COMMON_P_E_T_C: '图片预览组件提取文本_复制',
    /** 图片预览组件 */

    /** 切换新版UI */
    COMMON_S_N_B_1: '菜单_切换新版_按钮',
    COMMON_S_N_B_2: '更新弹窗_立即体验_按钮',
    COMMON_S_N_B_3: '回到旧版_按钮',
    // COMMON_S_N_B_4: '新版界面_回到旧版_按钮',
    COMMON_S_N_M: '更新弹窗显示',
    COMMON_S_N_M_C: '更新弹窗_关闭',
    /** 切换新版UI end */

    /** 自动化工作流引导 */
    A_F_W_G_0: '工作流引导弹窗_立即体验_按钮',
    A_F_W_G_1: '自动化列表头部引导提示_点击去使用_按钮',
};
